var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 512h482c8.284 0 15-6.716 15-15v-452c0-8.284-6.716-15-15-15h-46v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-60v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-150v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-60v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-46c-8.284 0-15 6.716-15 15v452c0 8.284 6.716 15 15 15zm15-30v-330h452v330zm31-422v16c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h60v16c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h150v16c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h60v16c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h31v62h-452v-62z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 212h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 242h30c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 302h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 332h30c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 302h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 302h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 392h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 392h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 362h-120c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15zm-15 60h-90v-30h90z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 182h-120c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15zm-15 60h-90v-30h90z",
    fill: "#000000",
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.715c4264a649db89abda0b2c4fdaac3c.svg";
export { ForwardRef as ReactComponent };